import * as tslib_1 from "tslib";
import React from 'react';
import { midPoint } from '../redux/scales';
var BubblyHeart = /** @class */ (function (_super) {
    tslib_1.__extends(BubblyHeart, _super);
    function BubblyHeart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BubblyHeart.prototype.render = function () {
        var _a = this.props, lovePercentage = _a.lovePercentage, size = _a.size;
        var offsetPercentage = 1 - (midPoint - lovePercentage) / midPoint;
        // since the heart is only a fraction of the viewport, we need to scale our offset
        // these numbers were achieved via trial and error
        var minShift = 23;
        var maxShift = 112;
        var offset = minShift + offsetPercentage * (maxShift - minShift);
        return this.renderHeart(offset, size);
    };
    BubblyHeart.prototype.renderHeart = function (offset, imageSize) {
        return (React.createElement("svg", { width: imageSize, height: imageSize, viewBox: "0 0 160 160", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("defs", null,
                React.createElement("pattern", { id: "waves", x: "0", y: "0", width: "521", height: "134", patternUnits: "userSpaceOnUse", viewBox: "0 -" + offset + " 521 134" },
                    React.createElement("path", { d: "M417.12 18.19c-37.61 37.61-48.71-55.62-104.33 0-37.61 37.61-48.9-55.62-104.52 0-37.61 37.61-48.71-55.62-104.33 0v.18C66.49 55.48 55.53-37.33 0 18.19v118.76h521.26V18.19c-37.61 37.62-48.51-55.62-104.14 0z", fill: "#00edb4" }),
                    React.createElement("animate", { attributeType: "XML", attributeName: "x", from: "0", to: "521", dur: "5s", repeatCount: "indefinite" }))),
            React.createElement("g", null,
                React.createElement("path", { d: "M48.82 55.81a19.61 19.61 0 0 0 0 27.88L80 114.75l31.18-31.06a19.61 19.61 0 0 0 0-27.88c-7.732-7.731-20.268-7.731-28 0L80 59l-3.16-3.19c-7.732-7.731-20.268-7.731-28 0h-.02z", stroke: "#FFF", strokeWidth: "2", opacity: ".65", fill: "url(#waves)" }))));
    };
    return BubblyHeart;
}(React.Component));
export { BubblyHeart };
export default BubblyHeart;
//# sourceMappingURL=BubblyHeart.js.map